import { rgba } from 'polished';
import styled from 'styled-components';
import { color, fontSize, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledPage = styled.div`
  --headingColor: #312784;
`;

export const StyledFooter = styled.div`
  background-image: linear-gradient(
      ${rgba('#1F1D26', 0.75)},
      ${rgba('#1F1D26', 0.75)}
    ),
    url('${getPublicPath('/images/stateSector/2023/hero-bg-sm.webp')}');
  background-size: cover;
  background-position: top center;
  padding: ${spacing('xl4')} ${spacing('md')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: ${spacing('md')};
  font-size: ${fontSize('xl')};
  color: ${color('text_default_inverse')};

  @media (min-width: ${screen('md')}) {
    background-image: linear-gradient(
        ${rgba('#1F1D26', 0.75)},
        ${rgba('#1F1D26', 0.75)}
      ),
      url('${getPublicPath('/images/stateSector/2023/hero-bg.webp')}');
  }
`;

export const StyledFooterActions = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${spacing('sm')};
`;
